import { createFileRoute } from "@tanstack/react-router";
import z from "zod";

import { AutoSignIn } from "@/features/auth/auto-sign-in";

export const Route = createFileRoute("/(auth)/auto-sign-in")({
  component: AutoSignIn,
  validateSearch: z.object({
    code: z.string().optional(),
    redirect_url: z.string().optional(),
  }),
});
